import {create} from 'zustand'

type FeedState = {
    isFetchingWithHostFilters: boolean
    showSearchBox: boolean
    search?: string
}

type FeedActions = {
    setIsFetchingWithHostFilters: (isFiltersChanged: boolean) => void
    setSearchParam: (searchValue?: string) => void
    setShowSearchBox: (show: boolean) => void
}

type FeedStore = FeedState & FeedActions

const initialFeed: FeedState = {
    isFetchingWithHostFilters: false,
    showSearchBox: false
}

export const useFeedStore = create<FeedStore>(set => ({
    ...initialFeed,

    setIsFetchingWithHostFilters: (isFiltersChanged: boolean) =>
        set(() => {
            return {isFetchingWithHostFilters: isFiltersChanged}
        }),

    setSearchParam: search =>
        set(() => ({
            search
        })),
    setShowSearchBox: show =>
        set(() => ({
            showSearchBox: show,
            search: undefined
        }))
}))

export default useFeedStore
